import {XauditModel} from '../xaudit.model';

export class CfgArClaimProcessorForLocation extends XauditModel {
  ClaimProcessorLocID: string;
  ClaimProcessorID: string;
  LOCID: number;
  isDefaultProcessor: boolean;
}
